module.exports = __webpack_public_path__ + "img/empty.e345c4e6.png";